import apollo from '@/apollo.js'
import gql from 'graphql-tag'

export const createBookmark = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation createBookmark($route: String!, $linkText: String!) {
          createBookmark(route: $route, linkText: $linkText) {
            id
            linkText
            route
            createdAt
            error
            message
          }
        }
      `),
      variables: { route: data.route, linkText: data.linkText }
    })
  return response.data.createBookmark
}

export const deleteBookmark = async (data) => {
  const response = await apollo.mutate(
    {
      mutation: gql(`
        mutation deleteBookmark($id: Int!) {
          deleteBookmark(bookmarkId: $id) { error message }
        }
      `),
      variables: { id: data.id }
    })
  return response.data.deleteBookmark
}
